var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 13.6663C11.1298 13.6663 13.6668 11.1293 13.6668 7.99968C13.6668 4.87006 11.1298 2.33301 8.00016 2.33301C4.87055 2.33301 2.3335 4.87006 2.3335 7.99968C2.3335 11.1293 4.87055 13.6663 8.00016 13.6663Z",
    fill: "#F64444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96655 4.98633L7.96655 8.63299",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98653 10.8657C7.98653 10.8767 7.97758 10.8857 7.96653 10.8857C7.95549 10.8857 7.94653 10.8767 7.94653 10.8657C7.94653 10.8547 7.95549 10.8457 7.96653 10.8457C7.97758 10.8457 7.98653 10.8547 7.98653 10.8657Z",
    fill: "white",
    stroke: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullExclamationIcon);
export default __webpack_public_path__ + "static/media/full-exclamation-icon.3deedcff5c15e7f80cca3ad5dabafbd5.svg";
export { ForwardRef as ReactComponent };